import { SNACKBAR_RENDER, SNACKBAR_CLOSE } from 'actions/snackbar'

export default function render(state={}, action={}) {
  switch (action.type) {
    case SNACKBAR_RENDER:
      return { open: true, ...action.snackbar }
    case SNACKBAR_CLOSE:
      return { open: false }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/snackbar.js